(function ($, Drupal) {
  Drupal.behaviors.mapFilters = {
    attach: function (context, settings) {
      const mapIframe = document.getElementById("wave2locator");
      // map data-filter-key keys to filter numbers
      const filters = {
        FCS: "0",
        ATMSF: "1",
        ESC: "2",
        BAR: "3",
        RETDEP: "4",
        ATMDP: "5",
      };

      $(".map-filter", context).each(function () {
        const filterButton = $(this);
        const filterKey = filterButton.data("filter-key");
        const filterNum = filters[filterKey] || "0"; // Map to filter number || default to '0'.

        const clickHandler = function () {
          sendCommand("clearfilters", "");
          sendCommand("checkfilter", filterNum);
          mapIframe.scrollIntoView({ behavior: "smooth" });
          return false;
        };

        filterButton.on("click", clickHandler);
      });
    },
  };
})(jQuery, Drupal);

function sendCommand(myCommand, myParam, myId) {
  const locatorTarget = document.getElementById("wave2locator");

  // Define the message object (in JSON format)
  const messageObject = {
    command: myCommand,
    parameter: myParam,
    identifier: myId,
  };

  // Convert the message object to a JSON string
  const messageString = JSON.stringify(messageObject);
  // Send the message to the iframe
  locatorTarget.contentWindow.postMessage(messageString, "*");
}

window.addEventListener("message", function (event) {
  const response = event.data;

  if (response.subject === "filters") {
    // Handle received filters data array
    const filtersData = response.contents;
    // Check if searchfilters exists in the parsed data
    if (filtersData && Array.isArray(filtersData)) {
      const searchFilters = filtersData;
    } else {
      console.error("Search filters array not found in UX Status Data");
    }
  }
  if (response.subject === "ux") {
    // Handle received UX status data array
    const statusData = response.contents;
    const statusDataObject = statusData;
  }
  if (response.subject === "locations") {
    // Handle received locations data
    const locationsData = response.contents;
  }
});
